export default {
  discount: 'Speichern {{discount}}',
};
